var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4669 18.8267L17.5869 24.9467C17.8367 25.1951 18.1747 25.3345 18.5269 25.3345C18.8792 25.3345 19.2171 25.1951 19.4669 24.9467C19.5919 24.8228 19.6911 24.6753 19.7588 24.5129C19.8265 24.3504 19.8613 24.1761 19.8613 24.0001C19.8613 23.8241 19.8265 23.6498 19.7588 23.4873C19.6911 23.3248 19.5919 23.1774 19.4669 23.0534L13.3336 16.9467C13.2086 16.8228 13.1094 16.6753 13.0417 16.5129C12.974 16.3504 12.9392 16.1761 12.9392 16.0001C12.9392 15.8241 12.974 15.6498 13.0417 15.4873C13.1094 15.3248 13.2086 15.1774 13.3336 15.0534L19.4669 8.94675C19.718 8.69744 19.8598 8.35862 19.861 8.0048C19.8623 7.65098 19.7229 7.31115 19.4736 7.06008C19.2243 6.80901 18.8855 6.66726 18.5316 6.66601C18.1778 6.66476 17.838 6.80411 17.5869 7.05342L11.4669 13.1734C10.7179 13.9234 10.2971 14.9401 10.2971 16.0001C10.2971 17.0601 10.7179 18.0767 11.4669 18.8267Z",
    fill: "#0A71AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.1a9a104469948f40e1bbc7580d1d1a34.svg";
export { ForwardRef as ReactComponent };